export default __webpack_public_path__ + "static/media/seed-crm.dddd8867.jpg";